import { render, staticRenderFns } from "./AddOrder.vue?vue&type=template&id=5f58cce3&scoped=true"
import script from "./AddOrder.vue?vue&type=script&lang=js"
export * from "./AddOrder.vue?vue&type=script&lang=js"
import style0 from "./AddOrder.vue?vue&type=style&index=0&id=5f58cce3&prod&lang=scss&scoped=true"
import style1 from "./AddOrder.vue?vue&type=style&index=1&id=5f58cce3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f58cce3",
  null
  
)

export default component.exports